module.exports = __webpack_public_path__ + "static/media/KM_ORU_110.b8e6a812.png";